var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"relative flex align-center items-center text-sm px-4 h-full rounded-none focus:outline-none border-b-2 hover:bg-gray-10",class:[
    _vm.$style.root,
    _vm.active ? 'border-primary font-bold' : 'border-transparent text-black-70'
  ],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),_c('div',{class:_vm.$style.focusState})],2)}
var staticRenderFns = []

export { render, staticRenderFns }